<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";

const {darkMode} = storeToRefs(useNamaFlagsStore());

</script>

<template>
    <q-card-actions class="tw-flex tw-flex-col tw-items-start">
      <q-skeleton type="text" :dark="darkMode" class="tw-w-[25%]"/>
      <q-skeleton type="text" :dark="darkMode" class="tw-w-[35%]"/>
    </q-card-actions>
</template>

<style scoped>

</style>
